import { useTranslation } from '@thoughtspot/i18n';
import React from 'react';
import { EMAIL_CUSTOMIZATION_CONSTANTS, TranslationKeys } from './constants';
import { getLogoSizeClass } from './email-customization-utils';
import styles from './email-customizations.module.scss';
export const EmailPreview = ({ settings }) => {
    const { t } = useTranslation();
    const logoUrl = settings.logo &&
        settings.logo !== EMAIL_CUSTOMIZATION_CONSTANTS.SAME_AS_STYLING
        ? settings.logo
        : EMAIL_CUSTOMIZATION_CONSTANTS.DEFAULT_LOGO_URL;
    const isShown = (value) => value === EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN;
    const hasAnyNotificationContent = isShown(settings.hideNotificationStatus) ||
        isShown(settings.hideModifyAlert) ||
        isShown(settings.hideUnsubscribeLink);
    const hasAnyMiddleSection = isShown(settings.mobileAppNudge) ||
        isShown(settings.hideErrorMessage) ||
        hasAnyNotificationContent;
    const hasAnyPrivacyLink = isShown(settings.hidePrivacyPolicy) ||
        isShown(settings.hideContactSupportUrl) ||
        settings.hideManageNotification === 'Shown';
    const hasAnyFooterContent = isShown(settings.hideProductName) ||
        isShown(settings.hideFooterPhone) ||
        isShown(settings.hideFooterAddress) ||
        hasAnyPrivacyLink;
    return (React.createElement("div", { className: styles.emailContainer },
        React.createElement("div", { className: styles.emailCard },
            React.createElement("div", { className: styles.emailContent },
                settings.hideLogoUrl !==
                    EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_HIDDEN && (React.createElement("div", { className: styles.logoSection },
                    React.createElement("div", { className: `${styles.logo} ${getLogoSizeClass(settings.logoSize, styles)}` },
                        React.createElement("img", { src: logoUrl ===
                                EMAIL_CUSTOMIZATION_CONSTANTS.DEFAULT_LOGO_URL
                                ? EMAIL_CUSTOMIZATION_CONSTANTS.DEFAULT_LOGO
                                : logoUrl, alt: t(TranslationKeys.PREVIEW_COMPANY_LOGO_ALT), className: styles.logoImage })))),
                React.createElement("div", { className: styles.alertTitle },
                    React.createElement("div", { className: styles.alertTitleText }, t(TranslationKeys.PREVIEW_TEST_EMAIL_TITLE))),
                React.createElement("table", { className: "text_block block-1", width: "100%", cellPadding: "0", cellSpacing: "0", role: "presentation", style: {
                        tableLayout: 'auto',
                        wordBreak: 'break-word',
                        border: '0',
                    } },
                    React.createElement("tr", null,
                        React.createElement("td", { className: "pad", style: { padding: '10px 30px' } },
                            React.createElement("div", { style: {
                                    backgroundColor: settings.cardBackgroundColor ||
                                        '#f4f4f4',
                                    borderRadius: '8px',
                                    padding: '16px 24px',
                                    fontFamily: 'Arial,sans-serif',
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                } },
                                React.createElement("p", { style: {
                                        margin: 0,
                                        fontSize: '18px',
                                        lineHeight: '28.8px',
                                    } },
                                    React.createElement("span", { style: {
                                            fontSize: '14px',
                                            color: '#4c4c4c',
                                        } }, t(TranslationKeys.PREVIEW_ANSWERS_UPDATE_MESSAGE, {
                                        replacementValueForAnswer: settings.replacementValueForAnswer ||
                                            t(TranslationKeys.PREVIEW_DEFAULT_ANSWER),
                                    }))),
                                React.createElement("p", { style: {
                                        margin: 0,
                                        fontSize: '14px',
                                        lineHeight: '28.8px',
                                    } },
                                    React.createElement("span", { style: {
                                            fontSize: '14px',
                                            color: '#4c4c4c',
                                        } }, t(TranslationKeys.PREVIEW_LIVEBOARD_UPDATE_MESSAGE, {
                                        replacementValueForLiveboard: settings.replacementValueForLiveboard ||
                                            t(TranslationKeys.PREVIEW_DEFAULT_LIVEBOARD),
                                    }))),
                                React.createElement("p", { style: {
                                        margin: 0,
                                        fontSize: '14px',
                                        lineHeight: '28.8px',
                                    } },
                                    React.createElement("span", { style: {
                                            fontSize: '14px',
                                            color: '#4c4c4c',
                                        } }, t(TranslationKeys.PREVIEW_SPOTIQ_UPDATE_MESSAGE, {
                                        replacementValueForSpotIQ: settings.replacementValueForSpotIQ ||
                                            t(TranslationKeys.PREVIEW_DEFAULT_SPOTIQ),
                                    }))))))),
                React.createElement("div", { className: styles.buttonSection },
                    React.createElement("div", { className: styles.buttonWrapper, style: settings.buttonColor !==
                            EMAIL_CUSTOMIZATION_CONSTANTS.DEFAULT_BLACK_COLOR
                            ? {
                                '--button-color': settings.buttonColor,
                            }
                            : {} },
                        React.createElement("button", { type: "button", className: `${styles.viewKpiButton} ${settings.buttonColor ===
                                EMAIL_CUSTOMIZATION_CONSTANTS.DEFAULT_BLACK_COLOR
                                ? styles.gradientButton
                                : styles.customColorButton}`, style: {
                                ...(settings.buttonColor !==
                                    EMAIL_CUSTOMIZATION_CONSTANTS.DEFAULT_BLACK_COLOR
                                    ? {
                                        backgroundColor: settings.buttonColor,
                                        borderColor: settings.buttonColor,
                                    }
                                    : {}),
                                color: settings.primaryTextColor,
                                fontWeight: 700,
                                fontSize: '14px',
                                '--button-text-color': settings.primaryTextColor,
                            } }, t(TranslationKeys.PREVIEW_VIEW_ANSWER_BUTTON)))),
                !settings.hide_ts_vocabulary_definitions && (React.createElement("div", { style: {
                        backgroundColor: '#ffffff',
                        borderRadius: '8px',
                        padding: '32px',
                        fontFamily: 'Arial,sans-serif',
                        fontSize: '14px',
                        lineHeight: '1.5',
                        color: '#333',
                    } },
                    React.createElement("div", { style: {
                            fontWeight: 'bold',
                            marginBottom: '8px',
                        } }, t(TranslationKeys.PREVIEW_VOCABULARY_ANSWER_HEADER, {
                        replacementValueForAnswer: settings.replacementValueForAnswer ||
                            t(TranslationKeys.PREVIEW_DEFAULT_ANSWER),
                    })),
                    React.createElement("div", { style: { marginBottom: '16px' } }, t(TranslationKeys.PREVIEW_VOCABULARY_ANSWER_DESCRIPTION, {
                        replacementValueForAnswer: settings.replacementValueForAnswer ||
                            t(TranslationKeys.PREVIEW_DEFAULT_ANSWER),
                    })),
                    React.createElement("div", { style: {
                            fontWeight: 'bold',
                            marginBottom: '8px',
                        } }, t(TranslationKeys.PREVIEW_VOCABULARY_LIVEBOARD_HEADER, {
                        replacementValueForLiveboard: settings.replacementValueForLiveboard ||
                            t(TranslationKeys.PREVIEW_DEFAULT_LIVEBOARD),
                    })),
                    React.createElement("div", null, t(TranslationKeys.PREVIEW_VOCABULARY_LIVEBOARD_DESCRIPTION, {
                        replacementValueForLiveboard: settings.replacementValueForLiveboard ||
                            t(TranslationKeys.PREVIEW_DEFAULT_LIVEBOARD),
                    })))),
                (hasAnyMiddleSection || hasAnyFooterContent) && (React.createElement("div", { className: styles.sectionDivider })),
                settings.mobileAppNudge ===
                    EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.mobileAppSection },
                        React.createElement("div", { className: styles.mobileAppContent },
                            React.createElement("div", { className: styles.mobileAppText },
                                React.createElement("div", { className: styles.mobileAppTitle }, t(TranslationKeys.PREVIEW_MOBILE_APP_TITLE)),
                                React.createElement("div", { className: styles.mobileAppDescription }, t(TranslationKeys.PREVIEW_MOBILE_APP_DESCRIPTION)),
                                React.createElement("div", { className: styles.storeButtons },
                                    React.createElement("a", { href: "https://thoughtspot.app.link/email", target: "_blank", rel: "noopener noreferrer" },
                                        React.createElement("img", { src: EMAIL_CUSTOMIZATION_CONSTANTS.IOS_BUTTON_IMAGE_URL, alt: t(TranslationKeys.PREVIEW_APP_STORE_ALT), className: styles.storeButton })),
                                    React.createElement("a", { href: "https://thoughtspot.app.link/email", target: "_blank", rel: "noopener noreferrer" },
                                        React.createElement("img", { src: EMAIL_CUSTOMIZATION_CONSTANTS.ANDROID_BUTTON_IMAGE_URL, alt: t(TranslationKeys.PREVIEW_GOOGLE_PLAY_ALT), className: styles.storeButton })))),
                            React.createElement("div", { className: styles.qrCodeSection },
                                React.createElement("a", { href: "https://thoughtspot.app.link/email", target: "_blank", rel: "noopener noreferrer" },
                                    React.createElement("img", { src: EMAIL_CUSTOMIZATION_CONSTANTS.QR_CODE_IMAGE_URL, alt: t(TranslationKeys.PREVIEW_QR_CODE_ALT), className: styles.qrCode }))))),
                    React.createElement("div", { className: styles.sectionDivider }))),
                settings.hideErrorMessage ===
                    EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement("div", { className: styles.notificationSection },
                    React.createElement("div", { className: styles.notificationText },
                        t(TranslationKeys.PREVIEW_ERROR_DETAILS),
                        React.createElement("br", null),
                        React.createElement("span", { style: {
                                color: '#9CA3AF',
                                fontSize: '12px',
                            } }, t(TranslationKeys.PREVIEW_ERROR_INCIDENT_ID))))),
                hasAnyNotificationContent && (React.createElement("div", { className: styles.notificationSection },
                    settings.hideNotificationStatus ===
                        EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement("div", { className: styles.notificationText }, t(TranslationKeys.PREVIEW_NOTIFICATION_MESSAGE, {
                        productName: settings.productName ||
                            t(TranslationKeys.PREVIEW_DEFAULT_PRODUCT_NAME),
                    }))),
                    (settings.hideModifyAlert ===
                        EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN ||
                        settings.hideUnsubscribeLink ===
                            EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN) && (React.createElement("div", { className: styles.notificationLinks },
                        settings.hideModifyAlert ===
                            EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement("a", { href: "http://thoughtspot.com/modify", target: "_blank", rel: "noreferrer" }, t(TranslationKeys.PREVIEW_MODIFY_ALERT_LINK))),
                        settings.hideModifyAlert ===
                            EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN &&
                            settings.hideUnsubscribeLink ===
                                'Shown' && (React.createElement("span", { style: { color: '#2770EF' } }, ' | ')),
                        settings.hideUnsubscribeLink ===
                            'Shown' && (React.createElement("a", { href: "https://thoughtspot.com/unsubscribe", target: "_blank", rel: "noreferrer" }, t(TranslationKeys.PREVIEW_UNSUBSCRIBE_LINK))))))),
                hasAnyFooterContent && (React.createElement("div", { className: styles.emailFooter },
                    settings.hideProductName ===
                        EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement("div", { className: styles.companySignature, style: { marginBottom: '4px' } },
                        React.createElement("div", { className: styles.signatureText },
                            React.createElement("span", { key: "product-name" }, settings.productName)))),
                    settings.hideFooterPhone ===
                        EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement("div", { className: styles.companySignature, style: { marginBottom: '4px' } },
                        React.createElement("div", { className: styles.signatureText },
                            React.createElement("span", { key: "mobile-number" }, settings.mobileNumber)))),
                    settings.hideFooterAddress ===
                        EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement("div", { className: styles.companySignature, style: { marginBottom: '4px' } },
                        React.createElement("div", { className: styles.signatureText },
                            React.createElement("span", { key: "footer-address" }, settings.footerAddress)))),
                    hasAnyPrivacyLink && (React.createElement("div", { className: styles.privacyLinks },
                        settings.hidePrivacyPolicy ===
                            EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN &&
                            settings.webLinkLabel1 && (React.createElement(React.Fragment, null,
                            React.createElement("a", { href: settings.webLinkAddress1, target: "_blank", rel: "noopener noreferrer" }, t(TranslationKeys.PRIVACY_POLICY)),
                            (settings.hideContactSupportUrl ===
                                'Shown' ||
                                settings.hideManageNotification ===
                                    'Shown') && (React.createElement("span", { style: {
                                    color: '#2770EF',
                                } }, ' | ')))),
                        settings.hideContactSupportUrl ===
                            EMAIL_CUSTOMIZATION_CONSTANTS.VISIBILITY_SHOWN && (React.createElement(React.Fragment, null,
                            React.createElement("a", { href: settings.contactSupportUrl, target: "_blank", rel: "noopener noreferrer" }, t(TranslationKeys.CONTACT_SUPPORT)),
                            settings.hideManageNotification ===
                                'Shown' && (React.createElement("span", { style: {
                                    color: '#2770EF',
                                } }, ' | ')))),
                        settings.hideManageNotification ===
                            'Shown' && (React.createElement("a", { href: "https://thoughtspot.com/manage-notifications", target: "_blank", rel: "noreferrer" }, t(TranslationKeys.MANAGE_NOTIFICATION_LABEL)))))))))));
};
//# sourceMappingURL=email-preview.component.js.map